import React from 'react'
import CanadaTemplateDefault from 'src/components/template/ca/'
import { canadaPlanData } from 'src/constants/planData/canadaPlanData'
import { useEPLImage } from 'src/modules/hooks/useEPLImage'

export default (props) => {
  const posterImg = useEPLImage()

  return (
    <CanadaTemplateDefault
      location={props.location}
      lang="en"
      market="canada"
      offerBanner={{
        title: ['Enter the code from BetMGM', 'to claim your FREE 1-month subscription'],
      }}
      hasOfferInput={true}
      ctaText="Redeem offer"
      // video={videos.canada_epl.videoUrl}
      poster={posterImg}
      noVideo={true}
      pageTitle="Watch the Premier League all season"
      title={
        <>
          Watch the Premier League <span className="desktop-line-break">all season</span>
        </>
      }
      subtitle="Unlock your FREE 1-month subscription now!"
      networkSet="canada_sports"
      logo="https://assets-imgx.fubo.tv/marketing/lp/images/partners/logo-betmgm.png?ch=width&auto=format,compress"
      logoHeight="80px"
      planCardsConfig={{
        plans: [canadaPlanData.sports],
      }}
    />
  )
}
